import { render, staticRenderFns } from "./QuestionAnxiety.vue?vue&type=template&id=950bf062&scoped=true"
import script from "./QuestionAnxiety.vue?vue&type=script&lang=js"
export * from "./QuestionAnxiety.vue?vue&type=script&lang=js"
import style0 from "./QuestionAnxiety.vue?vue&type=style&index=0&id=950bf062&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950bf062",
  null
  
)

export default component.exports